import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './components/ProtectedRoute';
import OnboardingRoute from './components/OnboardingRoute';
import AdminLayout from './components/AdminLayout';
import Signup from './pages/Signup';
import Signin from './pages/Signin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import BusinessSetup from './pages/BusinessSetup';
import Onboarding from './pages/Onboarding';
import WABASetup from './pages/WABASetup';
import Dashboard from './pages/Dashboard';
import Conversations from './pages/Conversations';
import Chat from './pages/Chat';
import Catalog from './pages/Catalog';
import Promotions from './pages/Promotions';
import Broadcast from './pages/Broadcast';
import BroadcastLists from './pages/BroadcastLists';
import CreateBroadcast from './pages/CreateBroadcast';
import Products from './pages/Products';
import Templates from './pages/Templates';
import TemplateDetail from './pages/TemplateDetail';
import TemplateSettings from './pages/TemplateSettings';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Billing from './pages/Billing';
import Invoices from './pages/Invoices';
import InvoiceDetail from './pages/InvoiceDetail';
import PhoneNumbers from './pages/PhoneNumbers';
import PhoneNumberDetail from './pages/PhoneNumberDetail';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import Webhooks from './pages/Webhooks';
import Media from './pages/Media';
import BusinessAccounts from './pages/BusinessAccounts';
import QualityRating from './pages/QualityRating';
import ApiLogs from './pages/ApiLogs';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import GoogleContactsCallback from './pages/GoogleContactsCallback';
import LandingPage from './pages/LandingPage';
import Leads from './pages/Leads';
import Appointments from './pages/Appointments';
import Feedback from './pages/Feedback';
import IntegrationApiKey from './pages/IntegrationApiKey';
import WhatsappBusinessApi from './landingPagies/WhatsappBusinessApi';
import NoPlatformCharge from './landingPagies/NoPlatformCharge';
import WhatsappCloudApi from './landingPagies/WhatsappCloudApi';
import WhatsappApi from './landingPagies/WhatsappApi';
import WhatsappApiPricing from './landingPagies/WhatsappApiPricing';
import WhatsappApiForSaas from './landingPagies/WhatsappApiForSaas';
import WhatsappApiForDevelopers from './landingPagies/WhatsappApiForDevelopers';
import WhatsappApiForAgencies from './landingPagies/WhatsappApiForAgencies';
import WhatsappChatbot from './landingPagies/WhatsappChatbot';
import WhatsappAutomation from './landingPagies/WhatsappAutomation';
import WhatsappCrm from './landingPagies/WhatsappCrm';
import WhatsappOtp from './landingPagies/WhatsappOtp';
import WhatsappNotifications from './landingPagies/WhatsappNotifications';
import WhatsappMarketing from './landingPagies/WhatsappMarketing';
import WhatsappApiIntegration from './landingPagies/WhatsappApiIntegration';
import WhatsappApiDocumentation from './landingPagies/WhatsappApiDocumentation';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/whatsapp-business-api/" element={<WhatsappBusinessApi />} />
          <Route path="/free-whatsapp-business-api/" element={<NoPlatformCharge />} />
          <Route path="/whatsapp-cloud-api/" element={<WhatsappCloudApi />} />
          <Route path="/whatsapp-api/" element={<WhatsappApi />} />
          <Route path="/whatsapp-api-pricing/" element={<WhatsappApiPricing />} />
          <Route path="/whatsapp-api-for-saas/" element={<WhatsappApiForSaas />} />
          <Route path="/whatsapp-api-for-developers/" element={<WhatsappApiForDevelopers />} />
          <Route path="/whatsapp-api-for-agencies/" element={<WhatsappApiForAgencies />} />
          <Route path="/whatsapp-chatbot/" element={<WhatsappChatbot />} />
          <Route path="/whatsapp-automation/" element={<WhatsappAutomation />} />
          <Route path="/whatsapp-crm/" element={<WhatsappCrm />} />
          <Route path="/whatsapp-otp/" element={<WhatsappOtp />} />
          <Route path="/whatsapp-notifications/" element={<WhatsappNotifications />} />
          <Route path="/whatsapp-marketing/" element={<WhatsappMarketing />} />
          <Route path="/whatsapp-api-integration/" element={<WhatsappApiIntegration />} />
          <Route path="/whatsapp-api-documentation/" element={<WhatsappApiDocumentation />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/business-setup" element={<BusinessSetup />} />
          <Route
            path="/onboarding"
            element={
              <OnboardingRoute>
                <Onboarding />
              </OnboardingRoute>
            }
          />
          <Route
            path="/waba-setup"
            element={
              <ProtectedRoute requireWABA={false}>
                <WABASetup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Dashboard />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/conversations"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Conversations />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/conversations/:customerId"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Conversations />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Customers />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route path="/auth/google-callback" element={<GoogleContactsCallback />} />
          <Route
            path="/customers/:customerId"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <CustomerDetail />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customers/:customerId/chat"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Chat />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/leads"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Leads />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/appointments"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Appointments />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalog"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Catalog />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/products/:catalogId"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Products />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/promotions"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Promotions />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/broadcast"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Broadcast />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
        
          <Route
            path="/broadcast/create"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <CreateBroadcast />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/broadcast-lists"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <BroadcastLists />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Analytics />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/templates"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Templates />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/templates/:templateId"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <TemplateDetail />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/template-settings"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <TemplateSettings />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Invoices />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices/:id"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <InvoiceDetail />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/phone-numbers"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <PhoneNumbers />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Orders />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <OrderDetail />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/phone-numbers/:id"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <PhoneNumberDetail />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/webhooks"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Webhooks />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/media"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Media />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-accounts"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <BusinessAccounts />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/quality-rating"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <QualityRating />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/api-logs"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ApiLogs />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Feedback />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/billing"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Billing />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Settings />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/integrations/token"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <IntegrationApiKey />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
